import { render, staticRenderFns } from "./StatusError.vue?vue&type=template&id=037a2698&scoped=true&"
import script from "./StatusError.vue?vue&type=script&lang=js&"
export * from "./StatusError.vue?vue&type=script&lang=js&"
import style0 from "./StatusError.vue?vue&type=style&index=0&id=037a2698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a2698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('037a2698')) {
      api.createRecord('037a2698', component.options)
    } else {
      api.reload('037a2698', component.options)
    }
    module.hot.accept("./StatusError.vue?vue&type=template&id=037a2698&scoped=true&", function () {
      api.rerender('037a2698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/StatusError.vue"
export default component.exports